
import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src
import Search from '@/components/home/search.vue'
import Banner from '@/components/home/banner.vue'
import Advert from '@/components/home/advert.vue'
import headerMenu from '@/components/header/header.vue';
import { reactive,provide, inject, ref, onMounted, getCurrentInstance,ComponentInternalInstance,onBeforeMount} from 'vue';
import {MenuMore} from '@/hooks/index'
import scrolltop from '@/components/scrolltop/index.vue'
import goodsList from '@/components/goods/goods-list.vue'
import WishList from '@/components/goods/wish-list.vue'
import headline from '@/components/headline/headline.vue'
import countDown from '@/components/count-down/count-down.vue'
import filtrate from '@/components/filtrate/filtrate.vue'
import iconDesign from '@/components/icon-design/icon-design.vue'
import card from '@/components/card/card.vue'
import seckillGoods from '@/components/count-down/seckill-goods.vue'
export default {
   components: {
    HelloWorld,
    Search,
    Banner,
    Advert,
    headerMenu,
    scrolltop,
    goodsList,
    WishList,
    headline,
    countDown,
    filtrate,
    iconDesign,
    card,
    seckillGoods
  },
  props: {},
  setup(props: object){
      const $http: any = inject('$http')
      const $store: any = inject('$store')
          const internalInstance  = getCurrentInstance();

     // internalInstance.appContext.config.globalProperties.site({code: 'ke'})
      const productList:Array<Object> = [
        {
          goods_id:0,
          icon_url:'https://image.kilimall.com/kenya/shop/activity/9b408da7e6a4d4b186e83e9db73516b3.png',
          goods_image_url:'https://image.kilimall.com/kenya/shop/store/goods/3906/2020/10/3906_06573851782348924_240.jpg.webp',
          name:'6Pcs Wine Glass Cups High Quality Spiral Glass Whisky Glassware(130018239) transparent 6pcs',
          promotion_price:'10499.00',
          is_free_shipping:true,
          discount_off:'-44%',
          marketprice:'18999.00',
          is_selected:1,
          rate:2,
          ratings:316,
        },
        {
          goods_id:1,
          icon_url:'https://image.kilimall.com/kenya/shop/activity/9b408da7e6a4d4b186e83e9db73516b3.png',
          goods_image_url:'https://image.kilimall.com/kenya/shop/store/goods/3906/2020/10/3906_06573851782348924_240.jpg.webp',
          name:'7Pcs Wine Glass Cups High Quality Spiral Glass Whisky Glassware(130018239) transparent 6pcs',
          promotion_price:'10499.00',
          is_free_shipping:true,
          discount_off:'-44%',
          marketprice:'18999.00',
          is_selected:1,
          rate:5,
          ratings:516,
        },
        {
          goods_id:2,
          icon_url:'https://image.kilimall.com/kenya/shop/activity/9b408da7e6a4d4b186e83e9db73516b3.png',
          goods_image_url:'https://image.kilimall.com/kenya/shop/store/goods/3906/2020/10/3906_06573851782348924_240.jpg.webp',
          name:'8Pcs Wine Glass Cups High Quality Spiral Glass Whisky Glassware(130018239) transparent 6pcs',
          promotion_price:'10499.00',
          is_free_shipping:true,
          discount_off:'-44%',
          marketprice:'18999.00',
          is_selected:1,
          rate:1,
          ratings:116,
        },
        {
          goods_id:3,
          icon_url:'https://image.kilimall.com/kenya/shop/activity/9b408da7e6a4d4b186e83e9db73516b3.png',
          goods_image_url:'https://image.kilimall.com/kenya/shop/store/goods/3906/2020/10/3906_06573851782348924_240.jpg.webp',
          name:'6Pcs Wine Glass Cups High Quality Spiral Glass Whisky Glassware(130018239) transparent 6pcs',
          promotion_price:'10499.00',
          is_free_shipping:true,
          discount_off:'-44%',
          marketprice:'18999.00',
          is_selected:1,
          rate:3,
          ratings:116,
        },
      ]
      const moreMenu:Array<MenuMore> = [
           {
              icon:'like-o',
              title:'Wish List',
              type:0,
              url:'/a',
          },
          {
              icon:'location-o',
              title:'Wish List',
              type:0,
              url:'/a',
          },
        ] 
        const brands:Array<Object> = [
          {
            brand_apply: 1,
            brand_class: "Phones &amp; Accessories",
            brand_id: 13,
            brand_initial: "H",
            brand_name: "HUAWEI",
            brand_pic: "04845143696554338_sm.jpg",
            brand_recommend: 1,
            brand_rewrite: "huawei",
            brand_sort: 0,
            class_id: 1057,
            image: "https://image.kilimall.com/kenya/shop/brand/04845143696554338_sm.jpg"
          },
          {
            brand_apply: 1,
            brand_class: "Smart Phones",
            brand_id: 594,
            brand_initial: "O",
            brand_name: "OLLA",
            brand_pic: "06361284799033953_small.jpg",
            brand_recommend: 1,
            brand_rewrite: "",
            brand_sort: 0,
            class_id: 1074,
            image: "https://image.kilimall.com/kenya/shop/brand/06361284799033953_small.jpg",
          },
          {
            brand_apply: 1,
            brand_class: "Mobile Phones",
            brand_id: 396,
            brand_initial: "O",
            brand_name: "OALE",
            brand_pic: "05883577791151127_small.jpg",
            brand_recommend: 0,
            brand_rewrite: "",
            brand_sort: 0,
            class_id: 1058,
            image: "https://image.kilimall.com/kenya/shop/brand/05883577791151127_small.jpg"
          },
          {
            brand_apply: 1,
            brand_class: "Smart Phones",
            brand_id: 409,
            brand_initial: "I",
            brand_name: "iBRIT",
            brand_pic: "05895677863298801_small.jpg",
            brand_recommend: 0,
            brand_rewrite: "",
            brand_sort: 0,
            class_id: 1074,
            image: "https://image.kilimall.com/kenya/shop/brand/05895677863298801_small.jpg"
          }
        ]
        const active = ref(1) 
        const menuDisplay = ref(false) 
        const showFiltrate = ref(true)  
        const {proxy}:any = getCurrentInstance() as ComponentInternalInstance;                       
         //调用header中的菜单
        const iconList = reactive([
         {
            imgsUrl:'https://image.kilimall.com/kenya/PcImages/ic_oversea_shipment@2x (1)_wps图片.png',
            title:'TVs',
            url:'/abc',
         },
         {
            imgsUrl:'https://image.kilimall.com/kenya/PcImages/ic_oversea_shipment@2x (1)_wps图片.png',
            title:'Smart Phones',
             url:'/abc',
         },
         {
            imgsUrl:'https://image.kilimall.com/kenya/PcImages/ic_oversea_shipment@2x (1)_wps图片.png',
            title:'Kitchen Ware',
             url:'/abc',
         },
         {
            imgsUrl:'https://image.kilimall.com/kenya/PcImages/ic_kilimall_dispatch@2x (2)_wps图片.png',
            title:'Shoes',
            url:'https://www.baidu.com/',
         },
         {
            imgsUrl:'https://image.kilimall.com/kenya/PcImages/ic_kilimall_dispatch@2x (2)_wps图片.png',
            title:'New Arrival',
            url:'https://www.baidu.com/',
         },
         {
            imgsUrl:'https://image.kilimall.com/kenya/PcImages/ic_kilimall_dispatch@2x (2)_wps图片.png',
            title:'Flash Sales',
            url:'https://www.baidu.com/',
         },
        ])                                       
        //调用header中的菜单
          const openMenu = ():void=>{
          proxy.$refs.headerMenu.openMenu()  
        }
        //调用header中的分享
        const shareEvent = ():void=>{
          proxy.$refs.headerMenu.transmitPopup()
        };
        //删除按钮
        const beforeClose = (state:Object):void=>{
          console.log('是否删除',state);
          //type判断是删除还是加购,goods_id为当前id         
        }
        //弹出筛选框按钮
        const popupClick = ():void=>{
            showFiltrate.value = false
        }

        let categorys = reactive({
          data:{}
        })
        //孙组件传递过来得数据
        const categoryList = (val:any):void=>{        
          console.log('父组件接受',val);          
        }
        //孙组件传递过来得数据
        const fixationVlaue = (val:String):void=>{
              console.log('我是什么，我是啥',val);             
        }
          onMounted( async ()=>{           
            const attrs = await proxy.$http.filtrateData({size: 40,
                          page: 1,
                          brand_id:'', 
                          keyword: 'shoes',
                          order:'',
                          min: '',
                          max: '',
                          free_shipping: '',
                          have_gift: '',
                          logistic_type: '',
                          search_type: 'filter_search'
                          })                         
               categorys.data = attrs.data
               console.log('----------',categorys.data);
               
         // internalInstance?.appContext.config.globalProperties.$http.site({code: 'ke'})
    });          
      return {
        moreMenu,
        active,
        openMenu,
        menuDisplay,
        shareEvent,
        productList,
        beforeClose,
        showFiltrate,
        categorys,
        categoryList,
        fixationVlaue,
        popupClick,
        iconList
       
      }
    }
  
}
